import React, {useContext, useEffect} from 'react';
import EditComponent from '../common/EditComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import SearchBox from '../common/SearchBoxComponent';
import TableComponent from '../common/TablePaginationComponent';

export default function GroupBranchParties() {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + `/society_organization/base/branch/api!branchPartyGroup.do`;

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'key',
			width: 100,
			sorter: (a, b) => a.key - b.key,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '姓名',
			dataIndex: 'memberName',
			width: 110,
			sorter: (a, b) => a.memberName.localeCompare(b.memberName),
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '出生日期',
			dataIndex: 'memberBorn',
			width: 140,
		},
		{
			title: '工作单位（或原单位）',
			dataIndex: 'memberUnit',
			width: 360,
		},
		{
			title: '学历程度',
			dataIndex: 'memberEducational',
			width: 140,
		},
		{
			title: '入党时间',
			dataIndex: 'memberDate',
			width: 140,
		},
		{
			title: '组织关系所在单位',
			dataIndex: 'memberZzgxUnit',
			width: 360,
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
				</>
			),
		},
	];

	const indexDataSource = dataSource.map((data, index) => ({key: index + 1, ...data}));
	return (
		<>
			<SearchBox/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}

